<template>
  <div class="payment-success-page">
    <div>
      <img src="@/assets/img/completed.png" alt="" />
      <p class="payment-success-message">
        TFSVN đã nhận được yêu cầu của Quý khách và sẽ xử lý trong<br />
        thời gian sớm nhất. Xin cảm ơn !!!
      </p>
      <div class="block md:flex justify-center">
        <router-link class="primary-button" :to="{ name: 'loanSummary' }" >
          Về trang chủ
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'RequestSuccess',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
